import { useCallback, useEffect, useState } from "react"
import axios from "axios"
import { API_BASE } from "@/config/api"
import { getSessionVertical, setSessionVertical } from "@/config/clinical-verticals"

const API = API_BASE

export function useClinicalContext() {
  const [clinical, setClinical] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async (sessionVertical) => {
    const sv = sessionVertical ?? getSessionVertical()
    try {
      const { data } = await axios.get(`${API}/clinical/context`, {
        params: sv ? { vertical: sv } : undefined,
      })
      setClinical(data)
    } catch {
      setClinical({
        primary_vertical: "psych",
        enabled_verticals: ["psych"],
        effective_vertical: "psych",
        effective_verticals: ["psych"],
        has_psych_tools: true,
        has_msk_tools: false,
      })
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  useEffect(() => {
    function onUpdated() {
      load()
    }
    window.addEventListener("asistentpersonal-clinical-settings-updated", onUpdated)
    return () => window.removeEventListener("asistentpersonal-clinical-settings-updated", onUpdated)
  }, [load])

  const setWorkingVertical = useCallback(
    (vertical) => {
      setSessionVertical(vertical)
      return load(vertical)
    },
    [load]
  )

  return {
    clinical,
    loading,
    reload: load,
    setWorkingVertical,
    enabledVerticals: clinical?.enabled_verticals || ["psych"],
    effectiveVertical: clinical?.effective_vertical || "psych",
    hasPsychTools: clinical?.has_psych_tools ?? true,
    hasMskTools: clinical?.has_msk_tools ?? false,
  }
}
